import {
  dataMap
} from '@/cllib/sys_lib'

import {
  dateOperating
} from '@/cllib/tools'

const state = {
  oilBigType: '',
  allCar: false,
  matchStatus: ['S', 'N'],
  adjustChooseCarTeam: '全部车队',
  adjustOrderDemand: true,
  adjustOrderIsSend: true,
  adjustDate: dataMap().tomorrowStr,
  adjustShowRouteOrderType: 'car',
  adjustLoadPiTag: 1,
  adjustPiGasTankId: 0,
  adjustPiGasTankIds: [],
  adjustCanPeratePeriod: {}
}

const getters = {
  adjustCanPeratePeriod: state => state.adjustCanPeratePeriod,
  adjustLoadPiTag: state => state.adjustLoadPiTag,
  adjustPiGasTankId: state => state.adjustPiGasTankId,
  adjustPiGasTankIds: state => state.adjustPiGasTankIds,
  adjustOrderDemand: state => state.adjustOrderDemand,
  adjustChooseCarTeam: state => state.adjustChooseCarTeam,
  adjustOrderIsSend: state => state.adjustOrderIsSend,
  oilBigType: state => state.oilBigType,
  allCar: state => state.allCar,
  matchStatus: state => state.matchStatus,
  adjustDate: state => state.adjustDate,
  adjustShowRouteOrderType: state => state.adjustShowRouteOrderType,
  searchOrderParm: state => {
    return {
      noPage: 1,
      sendTime: state.adjustDate,
      endTime: dateOperating.computeDay({days: 1, date: state.adjustDate, format: 'yy-mm-dd'}),
      oilType: ['联装', 'all'].includes(state.oilBigType) ? null : state.oilBigType,
      needVolume: 1
    }
  },
  searchSignCarParm: state => {
    return {
      noPage: 1,
      oilType: state.oilBigType === 'all' ? null : state.oilBigType,
      signDate: state.adjustDate
    }
  }
}

const actions = {
  setOilBigType ({ commit, dispatch, getters }, data) {
    commit('setOilBigType', data)
    dispatch('loadAllOrder', getters.searchOrderParm)
    dispatch('loadSignCar', getters.searchSignCarParm)
  },
  setAllCar ({ commit, dispatch }, data) {
    commit('setAllCar', data)
    dispatch('loadSignCar', getters.searchSignCarParm)
  },
  setAdjustCanPeratePeriod ({ commit }, data) {
    commit('setAdjustCanPeratePeriod', data)
  },
  setAdjustPiGasTankId ({ commit, dispatch }, data) {
    commit('setAdjustPiGasTankId', data)
    dispatch('updateAdjustLoadPiTag')
  },
  setAdjustPiGasTankIds ({ commit, dispatch }, data) {
    commit('setAdjustPiGasTankIds', data)
    dispatch('updateAdjustLoadPiTag')
  },
  updateAdjustLoadPiTag ({ commit, getters }) {
    commit('setAdjustLoadPiTag', getters.adjustLoadPiTag + 1)
  },
  setAdjustChooseCarTeam ({ commit, dispatch }, data) {
    commit('setAdjustChooseCarTeam', data)
  },
  setAdjustShowRouteOrderType ({ commit, dispatch }, data) {
    commit('setAdjustShowRouteOrderType', data)
  },
  setMatchStatus ({ commit, dispatch }, data) {
    commit('setMatchStatus', data)
  },
  setAdjustOrderIsSend ({ commit, dispatch }, data) {
    commit('setAdjustOrderIsSend', data)
  },
  setAdjustOrderDemand ({ commit, dispatch }, data) {
    commit('setAdjustOrderDemand', data)
  }
}

const mutations = {
  setAdjustCanPeratePeriod (state, data) {
    state.adjustCanPeratePeriod = data
  },
  setAdjustPiGasTankId (state, data) {
    state.adjustPiGasTankId = ~~data
    state.adjustPiGasTankIds = []
  },
  setAdjustPiGasTankIds (state, data) {
    state.adjustPiGasTankIds = data.map(v => ~~v)
    state.adjustPiGasTankId = 0
  },
  setAdjustLoadPiTag (state, data) {
    state.adjustLoadPiTag = data
  },
  setAdjustShowRouteOrderType (state, data) {
    state.adjustShowRouteOrderType = data
  },
  setAdjustOrderDemand (state, data) {
    state.adjustOrderDemand = data
  },
  setOilBigType (state, data) {
    state.oilBigType = data
  },
  setAdjustChooseCarTeam (state, data) {
    state.adjustChooseCarTeam = data
  },
  setAllCar (state, data) {
    state.allCar = data
  },
  setMatchStatus (state, data) {
    state.matchStatus = data
  },
  setAdjustOrderIsSend (state, data) {
    state.adjustOrderIsSend = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/adjust_order/search_block.js